import { useQuery } from '@tanstack/react-query'

import { API_CONSULTATION_GET_APPLICANT } from '@/services/consultations/url'
import { clientConsultationService } from '@/services/consultations'

export interface Applicant {
  id: number
  name?: string
  countryCallingCode?: string
  phoneNumber?: string
  isVerified: boolean
  country: string
}

const useApplicantQuery = () => {
  return useQuery<Applicant, Error>({
    queryKey: [API_CONSULTATION_GET_APPLICANT],
    queryFn: async (): Promise<Applicant> => {
      const response = await clientConsultationService.getApplicant()
      const memberDTO = response.data.memberDTO

      const phoneNumber = memberDTO.phoneNational
        ? memberDTO.phoneNational.startsWith('0')
          ? memberDTO.phoneNational
          : `0${memberDTO.phoneNational}`
        : ''

      return {
        id: memberDTO.id,
        name: memberDTO.name ?? undefined,
        countryCallingCode: memberDTO.phoneCountryCode ?? undefined,
        phoneNumber,
        isVerified: !!(memberDTO.phoneCountryCode && phoneNumber),
        country: memberDTO.country,
      }
    },
  })
}

export default useApplicantQuery
